import {styled, Typography} from '@mui/material';
import {ContentCardsProps} from './types';

const StyledNetworkTitle = styled(Typography)`
	font-weight: 600;
	margin-bottom: 8px;
	color: ${({theme}) => theme.colors.light.text.secondary};
`;

const ContentCards = styled('div')<ContentCardsProps>`
	grid-template-columns: repeat(4, 1fr);
	margin-top: ${({$isEmpty}) => ($isEmpty ? '24px' : '0px')};
	display: grid;
	gap: 24px 16px;

	@media (max-width: 870px) {
		justify-content: ${({$isEmpty}) => ($isEmpty ? 'start' : 'center')};
	}

	@media (max-width: 1723px) {
		grid-template-columns: repeat(3, 1fr);
	}

	@media (max-width: 1275px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (max-width: 768px) {
		grid-template-columns: repeat(1, 1fr);
	}
`;

const StyledContentCards = styled(ContentCards)<{$isGndiSaoPaulo: boolean}>`
	margin: ${({$isGndiSaoPaulo}) => ($isGndiSaoPaulo ? '24px 0 0' : '24px 0 8px')};
`;

export {StyledContentCards, StyledNetworkTitle};
